import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { DamsColors } from '../styles/DamsColors';
import { ContainedButton, OutlinedButton } from '../Button/AppButton';
import { DamsAppAsset } from '../../assets/registry';
import DamsPageHeaderProps from '.';




const AddItemPageHeader: React.FC<DamsPageHeaderProps> = ({
    title,
    subtitle,
    btnOnClick,
    
    addItemBtnOnClick,
    cancelBtnClick
}) => {
    return (
        <Box
            m={'32px'}
            height={66}
            sx={styles.headerContainer}
        >
            {/* Header Info  */}
            <Box width={'50%'}>
                <Typography
                    fontFamily={'Inter'}
                    fontSize={30}
                    fontWeight={600}
                    color={DamsColors.Text.PrimaryText}
                    noWrap>
                    {title ?? ' Add Asset'}
                </Typography>
            </Box>


            {/* Header Actions */}
            <Box gap={2} sx={{ display: 'flex', alignItems: 'center', }}>
                {
                    cancelBtnClick && 
                
                <OutlinedButton
                    height={40}
                    width={90}
                    title='Cancel'
                    onClick={cancelBtnClick}
                />
                }


                <ContainedButton
                    height={40}
                    width={90}
                    title='Save'
                    btnIconSrc={DamsAppAsset.icons.save}
                    onClick={() => {
                        if (addItemBtnOnClick !== undefined) {
                            addItemBtnOnClick()
                        }
                    }}
                />

            </Box>
        </Box>
    );
};

const styles = {
    headerContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        backgroundColor: 'white',
    }
}

export default AddItemPageHeader;
